<template>
	<!--提示文字类弹框-->
	<!--<text-dialog :change-show.sync="" :title-text=""></text-dialog>-->
	<!--
  text-dialog参数说明
    title-text: 标题文字
    change-show.sync: 是否显示弹框
  -->
	<div>
		<div class="dialog-400">
			<el-dialog :title="topText" :visible.sync="textDialog" :modal="false">
				<div class="margin-top-15 text-black">
					<div class="text-center" v-text="promptText"/>
					<slot/>
				</div>
				<div class="margin-top-20 text-center">
					<el-button class="u-btn-blue" @click="textDialog = false">我知道了</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ShowTextDialog',
	props: {
		changeShow: {
			type: Boolean,
			default: false,
			required: true,
		},
		titleText: String,
		promptText: String,
	},
	data() {
		return {
			textDialog: this.changeShow, // 弹框是否显示
			topText: this.titleText, // 头部文字
		};
	},
	watch: {
		changeShow(val) {
			this.textDialog = val;
		},
		titleText(val) {
			this.topText = val;
		},
		textDialog(val) {
			this.$emit('update:changeShow', val);
		},
	},
	created() {},
	methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	/* 修改el-dialog 弹出表格*/
	.dialog-400 .el-dialog {
		background-color: #fff;
		border: 1px solid #2196f3;
		box-shadow: 3px 3px 5px rgba(0, 0, 0, .6);
		width: 400px;
	}

	.dialog-400 .el-dialog__body {
		padding: 5px 20px 20px 20px;
	}

	.dialog-400 .el-dialog__header {
		background-color: #eee;
		padding: 8px 0;
		text-align: center;
	}

	.dialog-400 .el-dialog__title {
		font-size: 14px;
		color: #666;
	}

	.dialog-400 .el-dialog__headerbtn {
		display: none;
	}

	.dialog-400 .el-dialog__footer {
		padding: 20px 0 30px;
		text-align: center;
	}
</style>
